// src/styles/themes/dark.ts
import { light } from '.';

// DEFINIÇÃO DE ESTILOS DARK
const dark = {
  ...light,
};

export default dark;
